import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar", "label", "percentage"]
  static values = {
    datasets: Object,  // { enriched: {...}, raw: {...} }
    current: String,    // "enriched" or "raw"
    percentageType: String // "applicable", "not_applicable", "not_determinable"
  }

  connect() {
    this.animateTransition(this.datasetsValue[this.currentValue])
  }
  
  toggle() {
    const newDataset = this.currentValue === "enriched" ? "raw" : "enriched"
    this.animateTransition(this.datasetsValue[newDataset])
    this.currentValue = newDataset
  }

  // Called by findings-toggle controller via outlet
  syncToDataset(dataset) {
    // Only update if we're changing to a different dataset
    if (this.currentValue !== dataset) {
      this.animateTransition(this.datasetsValue[dataset])
      this.currentValue = dataset
    }
  }
  
  animateTransition(newData) {
    // Add up the values of all keys in newData
    const denominator = Object.values(newData).reduce((acc, curr) => acc + curr, 0)
    this.barTargets.forEach(bar => {
      const type = bar.dataset.type
      const newWidth = newData[`${type}_count`] / denominator * 100
      
      bar.animate(
        [{ width: bar.style.width }, { width: `${newWidth}%` }],
        { duration: 500, easing: 'ease-in-out', fill: 'forwards' }
      )
      
      bar.style.width = `${newWidth}%`
      bar.title = `${newData[`${type}_count`]} ${type} attributes`
    })
    // Update label counts with animated number transitions
    this.labelTargets.forEach(label => {
      const type = label.dataset.type
      const newCount = newData[`${type}_count`]
      this.animateCount(label, newCount)
    })
    this.percentageTargets.forEach(percentage => {
      const newPercentage = newData[`${this.percentageTypeValue}_count`] / denominator * 100
      this.animatePercentage(percentage, newPercentage)
    })

  }

  animatePercentage(element, targetPercentage) {
    const currentPercentage = parseInt(element.innerText) || 0
    const duration = 500 // matches CSS transition
    const steps = 30
    const increment = (targetPercentage - currentPercentage) / steps
    const stepDuration = duration / steps

    let current = currentPercentage
    let step = 0

    const timer = setInterval(() => {
      step++
      current += increment
      
      if (step >= steps) {
        element.textContent = Math.round(targetPercentage)
        clearInterval(timer)
      } else {
        element.textContent = Math.round(current)
      }
    }, stepDuration)
  }
  
  animateCount(element, targetCount) {
    const currentCount = parseInt(element.textContent) || 0
    const duration = 500 // matches CSS transition
    const steps = 30
    const increment = (targetCount - currentCount) / steps
    const stepDuration = duration / steps
    
    let current = currentCount
    let step = 0
    
    const timer = setInterval(() => {
      step++
      current += increment
      
      if (step >= steps) {
        element.textContent = targetCount
        clearInterval(timer)
      } else {
        element.textContent = Math.round(current)
      }
    }, stepDuration)
  }
}